import { UiFlags } from '@tassat/common-definitions';
import { browserLocalStore, browserSessionStore } from '@tassat/utility';
import * as jwt from 'jsonwebtoken';

import authService from './auth/AuthService';

class UiManager {
    initializeWindowInterface() {
        //create an interface to interact with the UI flags.
        //values are passed as comma-separated values, i.e.,
        //setUiFlags('DO_NOT_HIDE?sub=keycloak|123456789,DO_NOT_AUTH?sub=keycloak|123456789')
        window.setUiFlags = (string) => {
            const token = browserSessionStore.getItem('id_token');
            const decodedToken = jwt.decode(token) || {};
            const keys = string.trim()
                .split(',');
            let warrantsLogout = false;

            for (const key of keys) {
                const formattedKey = key.trim();

                if (formattedKey) {
                    const [ flag, params ] = formattedKey.split('?');
                    const subValue = params.trim()
                        .split('=')[1];

                    //normalize behavior to verify params when setting ui flags.
                    if (decodedToken.sub === subValue) {
                        //params verified, then set it to local storage so it can be verified when getting it back.
                        browserLocalStore.setItem(flag.trim(), subValue);

                        //force logout only for JWT encryption
                        if (flag.trim() === UiFlags.NO_ID_TOKEN_ENCRYPTION) {
                            warrantsLogout = true;
                        }
                    }
                }
            }

            if (warrantsLogout) {
                authService.logout();
            } else {
                window.location.reload();
            }
        };

        window.removeUiFlags = (string) => {
            const keys = string.trim()
                .split(',');
            let warrantsLogout = false;

            for (const key of keys) {
                const formattedKey = key.trim();

                if (formattedKey) {
                    if (formattedKey === UiFlags.NO_ID_TOKEN_ENCRYPTION && browserLocalStore.includes(UiFlags.NO_ID_TOKEN_ENCRYPTION)) {
                        warrantsLogout = true;
                    }

                    browserLocalStore.removeItem(formattedKey);
                }
            }

            if (warrantsLogout) {
                authService.logout();
            } else {
                window.location.reload();
            }
        };

        window.removeAllUiFlags = () => {
            let warrantsLogout = false;

            for (const key in UiFlags) {
                const flag = UiFlags[key];

                if (flag === UiFlags.NO_ID_TOKEN_ENCRYPTION && browserLocalStore.includes(flag)) {
                    warrantsLogout = true;
                }

                browserLocalStore.removeItem(flag);
            }

            if (warrantsLogout) {
                authService.logout();
            } else {
                window.location.reload();
            }
        };
    }
}

const uiManager = new UiManager();

export default uiManager;